import { render, staticRenderFns } from "./OfcPlayer.vue?vue&type=template&id=3ef79bd8&scoped=true&"
import script from "./OfcPlayer.vue?vue&type=script&lang=js&"
export * from "./OfcPlayer.vue?vue&type=script&lang=js&"
import style0 from "./OfcPlayer.vue?vue&type=style&index=0&id=3ef79bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef79bd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VTooltip})
